<template>
    <transition name="modal-fade">
        <div class="modal-overlay">
            <div class="modal-content hide-scrollbar" @click.stop>
                <div style="text-align:right; margin:8px -16px -40px 0; z-index:999;"><span class="material-icons" @click="$emit('close-modal')">close</span></div>


                <div class="col-12 title text-center" >
                   Remind your Client to pay!
                </div>

                <small class="col-12">
                    If you have completed certain tasks or are very close to being done, you may use this function to send your client a SMS message to remind them to have payment ready.
                </small>

                <div class="row" v-show="showReminderList" style="margin-bottom: 16px;">
                    <div class="col-12 reminder-box" v-for="(obj) in paymentData.Terms" v-bind:key="obj" >
                        <div  style="margin-top:8px; flex:1" v-if="paymentData.Mode == 'percentage' ">
                            If <b>{{ obj.Name }}</b> is done or nearing completion, then press REMIND to remind your Client to pay {{formatAsCurrency((paymentData.TotalCost - paymentData.Deposit)*obj.Amount/100)}}+ GST/HST 
                        </div>
                        <div v-else style="margin-top:8px; flex:1">
                            If <b>{{ obj.Name }}</b> is done or nearing completion, then press REMIND to remind your Client to pay {{formatAsCurrency(obj.Amount)}} + GST/HST 
                        </div>
                        <div v-if="obj.RemindedTime==null" class="confirm-button"  style="font-size: 10px; height:30px;  margin:8px 0; min-width: 98px; text-align: center;" @click="Remind(obj);">REMIND</div>
                        <div v-else class="disabled-button" style="font-size: 10px; height:30px;  margin:8px 0; min-width: 98px; text-align: center;" >Reminder Sent</div>
                    </div>
                   
                </div>
                <div class="row" v-show="!showReminderList">
                    <div class="col-12">
                        <textarea v-model="message" class="form-control" style="height: 100px; margin: 16px 0; font-size: 12px;" ></textarea>
 
                    </div>
                    <div class="col-12" v-show="showDateTimePicker">
                        <div class="datetime-picker"  style="margin: 8px 0;text-align: center;">

                            <n-date-picker 
                                style="width: fit-content; margin: auto;"
                                v-model:value="scheduleTime" 
                                type="datetime"
                                :is-date-disabled="disablePreviousDate"
                                :format="format"
                                clearable
                                />

                            </div>
                    </div>
                    <div class="col-12 popup-actions">
                        <div class="cancel-button"  style="font-size: 10px; height:30px;  margin:8px 0;" @click="cancel();">BACK</div>
                        <div class="confirm-button" v-show="!showDateTimePicker"  style="font-size: 10px; height:30px;  margin:8px 0;" @click="send(true);">SEND NOW</div>
                        
                        <div class="confirm-button"  style="font-size: 10px; height:30px;  margin:8px 0;" @click="scheduleLater();">{{scheduleButton}}</div>
                        
                    </div>
                </div>
                
            </div>


            <CustomPopup :visible="showPopup"
                         :icon="popupIcon"
                         :iconSrc="popupIconSrc"
                         :iconColor="iconColor"
                         :title="popupTitle"
                         :content="content"
                         :cancelText="cancelText"
                         :confirmText="confirmText"
                         :confirmButtonType="confirmButtonType"
                         :confirmAction="currentConfirmAction"
                         @cancel="onCancel" />

        </div>
    </transition>

</template>

<script>

import CustomPopup from './CustomPopup.vue';

    export default {

        components: { CustomPopup },

        data() {
            return {

                contractId: null,
                paymentData: {Deposit: 0, DepositDate: 0, Mode: '', Terms: []},
                showReminderList: true,
                message: '',

                TermId : null,
                scheduleTime: null,

                format: 'yyyy-MM-dd - HH:mm',
                scheduleButton: 'SCHEDULE LATER',

                showDateTimePicker: false,

                //Custom Popup
                showPopup: false,
                popupIcon: null, // Set to null since we'll use an image
                popupIconSrc: '', // Use this variable to hold the image path
                iconColor: '',
                popupTitle: '',
                content: '',
                cancelText: '',
                confirmText: '',
                confirmButtonType: 'primary',
                currentConfirmAction: null,
            }
        },

        
        mounted() {
            

        },
       
        methods: {

            disablePreviousDate(ts) {
                return ts < new Date().getTime() - 24 * 60 * 60 * 1000;
            },
            scheduleLater(){
                if(!this.showDateTimePicker){
                    this.showDateTimePicker = true;
                    this.scheduleButton = 'SEND';
                }else{

                    if(this.scheduleTime == null){
                        this.$emit('alertMessage', "Please select a date and time.");
                        return;
                    }
                    //console.log("Schedule Time", this.scheduleTime);

                    //console.log("Schedule datetime",new Date(this.scheduleTime).toLocaleString());

                    //return
                    this.send(false);
                }
                

            },
            send(sendNow){
                console.log("send", this.TermId,  this.message);
 
                var data = {};
                data.id = this.contractId;
                data.termId = this.TermId;
                data.message = this.message;
                data.scheduledTime = new Date(this.scheduleTime);

                if(sendNow){
                    data.scheduledTime = null ;
                }

                console.log("send data", data);

                this.$http.request("post", "/api/app/contract/sendtermreminder", data).then(res => {

                    console.log("send", res);                      

                    if (res?.Type == 200) {                  
                        if(sendNow){
                            this.$emit('alertMessage', "Reminder Sent Successfully.");
                        }else{
                            this.$emit('alertMessage', "Schedule reminder is now saved.  Your reminder will be sent at the following date and time - " + new Date(this.scheduleTime).toLocaleString());
                        }     
                      

                        this.$emit('close-modal');
                        this.showDateTimePicker = false;
                        this.scheduleButton = 'SCHEDULE LATER';
                        this.showReminderList = true;

                    }else{
                        this.$emit('alertMessage', res?.Content);
                    }
                }).finally(() => {
                    
                   
                    
                });

            },
            cancel() {
                if(this.showDateTimePicker){
                    this.showDateTimePicker = false;
                    this.scheduleButton = 'SCHEDULE LATER';
                    return;
                }
                this.showReminderList = true;
            },

            Remind(obj) {  
                //console.log("Remind", obj, this.paymentData);
                let amount = obj.Amount;
                if(this.paymentData.Mode == 'percentage'){
                    amount = (this.paymentData.TotalCost - this.paymentData.Deposit)*obj.Amount/100;
                }

                let _amount = this.formatAsCurrency(amount);
                if(this.$core.data.Business.GstNumber != null && this.$core.data.Business.GstNumber != ''){_amount += ' + GST/HST';}

                this.message = this.$core.data.ReminderMsg.replace('###Type###', obj.Name).replace('###Amount###', _amount );

                
                this.TermId = obj.Id;
                this.showReminderList = false;
            },

            formatAsCurrency(value) {
                if (value === null || value === undefined || isNaN(value)) return "";
                return new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                }).format(value);
            },
            dataUpdate(obj) {

                //console.log("dataUpdate", obj);
                this.contractId = obj.Id;
                this.paymentData = obj.Data.Payment;

                console.log("dataUpdate", this.contractId, this.paymentData);
            },
 

            onCancel() {
                this.showPopup = false;
            },

        }
    }
</script>

<style scoped>
    
    
    .border {
        border: 1px solid #ccc !important;
        border-radius: 10px;
    }
    .reminder-box {
        border-radius: 10px;
        padding: 8px 16px;
        margin: 8px 0px;
        box-shadow: rgba(0,0,0,.2) 1px 1px;
        -webkit-box-shadow: rgba(0,0,0,.2) 1px 1px;
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        background-color: #f1f2f6;
        gap:8px;
    }
    .modal-overlay {
        z-index: 999;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000000da;
 
    }

    .modal-content {
        background-color: white;
        height: fit-content;
        width: 800px;
        max-width: 90vh;
        max-height: 90vh;
        margin: auto 16px;
        padding: 0px 24px;
        border-radius: 20px;
        overflow: auto;
    } 

    .check {
        width: 150px;
    }

   
    p {
        /* font-weight: 500; */
        font-size: 16px;
        margin: 20px 0;
    }

    button {
        background-color: #ac003e;
        width: 150px;
        height: 40px;
        color: white;
        font-size: 14px;
        border-radius: 16px;
        margin-top: 50px;
    }

    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.5s ease;
    }


    .popup-actions{display:flex; gap: 16px; justify-content:center; margin-bottom: 16px;}

/* Basic button styles */
    .popup-actions div {           
        border: none;
        min-width: 98px;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
       text-align: center;
    }

        /* Confirm Button (Success) */
    .confirm-button {
        align-self: center;
        background-color: #198754; /* green */
        color: white;
        padding: 8px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s ease;
    }

        .confirm-button:hover {
            background-color: #43a047;
        }
    
    .disabled-button {
        align-self: center;
        background-color: #ccc; /* gray */
        color: white;
        padding: 8px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s ease;
    }
    .disabled-button:hover {
            background-color: #5e5858da;
        }

     /* Cancel Button */
     .cancel-button {
        background-color: #e0e0e0; /* light gray */
        color: #555; /* dark gray */
        padding: 8px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s ease;
        margin-right: 8px;
    }

        .cancel-button:hover {
            background-color: #cccccc;
        }

</style>